import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "youtube--sprite",
  "use": "youtube--sprite-usage",
  "viewBox": "0 0 24 18",
  "content": "<symbol viewBox=\"0 0 24 18\" id=\"youtube--sprite\">\n<path d=\"M19.615 0.184123C16.011 -0.0618739 7.984 -0.060874 4.385 0.184123C0.488 0.450119 0.029 2.80409 0 9C0.029 15.1849 0.484 17.5489 4.385 17.8159C7.985 18.0609 16.011 18.0619 19.615 17.8159C23.512 17.5499 23.971 15.1959 24 9C23.971 2.81509 23.516 0.451119 19.615 0.184123ZM9 12.9999V5.00006L17 8.993L9 12.9999Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol